import React from "react";
import { useRef, forwardRef, useImperativeHandle, useState, useEffect } from "react";
import classNames from "classnames";

/**
 * - Component that updates text efficiently and resets after inactivity
 * - display timeout is the time for which current text shows 
 *   and then switches to defaultText
 * - Added class pointer-events-none so that rest UI elemnts 
 *   are not blocked by the progressbar.
 */
const AudioInputProgressBar = forwardRef(({ 
  defaultText = "", className="" }, ref) => {
    // "Transcribing..."
  const [text, setText] = useState(defaultText);
  const lastUpdateRef = useRef(null);
  const[showProgress, setShowProgress]=useState(false)

  // Expose methods to the parent
  useImperativeHandle(ref, () => ({
    updateText(newText, displayTimeOut=500) {
      if(!showProgress)setShowProgress(true)
      if (newText !== text) {  // Update only if different
        setText(newText);
      }
      restartResetTimer(displayTimeOut);
    }
  }));

  // Function to restart the inactivity reset timer
  const restartResetTimer = (displayTimeOut) => {
    if (lastUpdateRef.current) clearTimeout(lastUpdateRef.current);
    lastUpdateRef.current = setTimeout(() => {
      setText(defaultText);
      setShowProgress(false)
    }, displayTimeOut); // Reset to default after 500ms of inactivity
  };

  useEffect(() => {
    return () => clearTimeout(lastUpdateRef.current); // Cleanup on unmount
  }, []);

 return (
    <div className="flex flex-row items-center 
    justify-center z-50 pointer-events-none">
    <div className={classNames(
      " text-teal-600  text-sm px-4 ",
       className)}>{text}</div>
   {  showProgress &&   
    <div className={classNames(
      "inline-block text-teal-600 pointer-events-none ",
       className)}>
      <svg
        className="animate-spin rounded-full h-4 w-4 border-t-1 border-b-1"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
      >
        <circle
          className="opacity-25"
          cx="12"
          cy="12"
          r="10"
          stroke="currentColor"
          strokeWidth="2"
        ></circle>
        <path
          className="opacity-75"
          fill="currentColor"
          d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
        ></path>
      </svg>
    </div>
  }
    </div>
);
});
/** 
const AudioInputProgressBar = ({progressBarText, className="" }) => {
    const timeoutRef = useRef(null);

  function audioDataReceived(audioArr) {
    if (!audioArr) return;

    // Update to "speaking..." only if not already set (avoids unnecessary re-renders)
    setProgressBarText((prev) => (prev !== "speaking..." ? "speaking..." : prev));

    // Clear the previous timeout
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }

    // Set "transcribing..." after 300ms of inactivity
    timeoutRef.current = setTimeout(() => {
      setProgressBarText("transcribing...");
    }, 500);
  return (
    <div className="flex flex-row items-center 
    justify-center">
    <div>{progressBarText}</div>
    <div className={classNames(
      "inline-block text-teal-600  mt-32  z-50 pointer-events-none ",
       className)}>
      <svg
        className="animate-spin rounded-full h-8 w-8 border-t-1 border-b-1"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
      >
        <circle
          className="opacity-25"
          cx="12"
          cy="12"
          r="10"
          stroke="currentColor"
          strokeWidth="2"
        ></circle>
        <path
          className="opacity-75"
          fill="currentColor"
          d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
        ></path>
      </svg>
    </div>
    </div>
);
};
*/
/*

IndefiniteProgressBarWithText.defaultProps = {
  className: "text-teal-600"
};
*/

export {AudioInputProgressBar}

